import React from "react";
import { motion } from "framer-motion";
import {
  Plant,
  Carrot,
  AppleLogo,
  Wine,
  Flower,
  Tree,
  Truck,
  TreeEvergreen,
  Buildings,
  Mountains,
} from "@phosphor-icons/react";

const branches = [
  { Icon: Plant, label: "Ackerbau" },
  { Icon: Carrot, label: "Gemüsebau" },
  { Icon: AppleLogo, label: "Obstbau" },
  { Icon: Wine, label: "Weinbau" },
  { Icon: Flower, label: "Gartenbau" },
  { Icon: Tree, label: "Baumschulen" },
  { Icon: Truck, label: "Lohnunternehmen" },
  { Icon: TreeEvergreen, label: "Forst" },
  { Icon: Mountains, label: "Garten- & Landschaftsbau" },
  { Icon: Buildings, label: "Kommunen" },
];

export const Audience = () => {
  return (
    <section
      id="zielgruppe"
      data-testid="audience-section"
      className="relative py-24 sm:py-32 bg-bone-100/70"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-terracotta mb-3">
            Zielgruppe
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-forest-900 tracking-tight">
            Für wen ist <span className="text-forest-600">Plantus</span> geeignet?
          </h2>
          <p className="mt-5 font-body text-base sm:text-lg text-[#4A524C]">
            Für alle Betriebe, die Pflanzenschutzmittel dokumentieren müssen.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
          {branches.map(({ Icon, label }, i) => (
            <motion.div
              key={label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.04, ease: "easeOut" }}
              data-testid={`audience-${label.toLowerCase().replace(/[^a-z]/g, "")}`}
              className="group bg-white border border-bone-200 rounded-2xl p-5 flex flex-col items-start gap-3 hover:border-forest-100 hover:shadow-sm transition"
            >
              <div className="w-11 h-11 rounded-xl bg-forest-50 border border-forest-100 flex items-center justify-center group-hover:scale-105 transition">
                <Icon size={22} weight="duotone" className="text-forest-700" />
              </div>
              <div className="font-heading text-sm sm:text-base font-medium text-forest-900 leading-tight">
                {label}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          className="mt-14 relative rounded-3xl bg-forest-700 text-white px-7 sm:px-12 py-10 sm:py-12 overflow-hidden"
        >
          <div
            className="absolute inset-0 opacity-15"
            style={{
              backgroundImage:
                "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.6) 1px, transparent 0)",
              backgroundSize: "26px 26px",
            }}
          />
          <div className="relative max-w-3xl">
            <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-terracotta mb-3">
              Egal ob 20 oder 2.000 Hektar
            </div>
            <p className="font-heading text-xl sm:text-2xl lg:text-3xl leading-snug">
              Plantus unterstützt alle{" "}
              <span className="text-terracotta">beruflichen Anwender</span>{" "}
              von Pflanzenschutzmitteln bei einer einfachen, digitalen und
              rechtssicheren Dokumentation.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
